<template>
    <ValidationObserver ref="observer">
        <form ref="form" slot-scope="{ validate }" @submit.prevent="validate().then(submit)" v-on:keyup.enter="validate().then(submit)">
            <ion-grid>
                <register-form-fields ref="formFields" :formData="formData" @input="formData = $event.value"/>
                <ion-row>
                    <ion-col>
                        <ion-item lines="none" class="ion-no-padding ion-no-margin">
                            <ion-button :disabled="submitting" @click="validate().then(submit)"
                                        expand="block" size="default" shape="round" style="margin: 10px auto 0;">
                                {{ $t('ncrypt.register') }}
                            </ion-button>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </form>
    </ValidationObserver>
</template>

<script>
    import RegisterFormFields from "./RegisterFormFields";
    import {ValidationObserver} from "vee-validate";

    export default {
        name: "RegisterForm",
        components: {
            ValidationObserver,
            RegisterFormFields,
        },
        props: {
            initialEmail: {type: String, default: undefined},
        },
        data() {
            return {
                submitting: false,
                formData: {
                    email: this.initialEmail,
                    password: null,
                    password_confirmation: null,
                },
            }
        },
        methods: {
            async submit() {
                this.submitting = true;

                this.$refs.formFields
                    .$once('registered', (data) => {
                        this.$emit('registered', data);
                        this.submitting = false;
                    })
                    .$once('register-error', (data) => {
                        this.$emit('register-error', data);
                        this.submitting = false;
                    })
                    .submit();
            },
        },
    }
</script>
